export enum MERCHANT_CHATBOT_KEYS {
	ONLINE_MERCHANT_CALLBACK_BOT_KEY = 'NEED_TO_ONBOARD',
	ONLINE_MERCHANT_REFUND = 'Refund',
	SETTLEMENT_CHATBOT = 'settlementNotReceived',
	TRANSACTION_CHATBOT = 'Transaction',
	B2B_PG_GENERIC = 'B2BPG Generic',
}
